import api from '@/apis'
import Vuetify from '@/plugins/vuetify'

export default {
  state: {
    submit_btn_disable: false,
    visibility: false,
    item: null
  },
  mutations: {
    INIT_WAIT_APPROVAL_DIALOG(state, payload) {
      state.visibility = true
      state.item = payload.item
    },
    SET_WAIT_APPROVAL_DIALOG_SUBMIT_BTN_DISABLE(state, payload) {
      state.submit_btn_disable = payload
    },
    RESET_WAIT_APPROVAL_DIALOG(state) {
      state.visibility = false
      setTimeout(() => {
        state.item = null
      }, 100)
    }
  },
  actions: {
    async getApprovalStatus({ rootState, commit, dispatch }, payload) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: Vuetify.locale.t('$vuetify.__SnackBar.loading', ''), loading: true })

        const device_id = rootState.auth.selected_device
        const response = await api.getApprovalStatus({ params: { device_id: device_id } })
        if (response.data.success) {
          const data = response.data.data
          if (data.can_submit) dispatch('initChangeApprovalDialog', { mode: 'editor', device_id: payload.device_id, device_name: payload.device_name })
          else commit('INIT_WAIT_APPROVAL_DIALOG', { item: { device_id: payload.device_id, device_name: payload.device_name, ...data } })

          commit('SET_SNACKBAR', { status: true, color: 'success', text: Vuetify.locale.t('$vuetify.__SnackBar.load', ''), icon: 'check', timeout: '2000' })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_WAIT_APPROVAL_DIALOG_SUBMIT_BTN_DISABLE', false)
      }
    },
    async cancelChangesSubmission({ state, commit }) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: Vuetify.locale.t('$vuetify.__SnackBar.canceling'), loading: true })
        commit('SET_WAIT_APPROVAL_DIALOG_SUBMIT_BTN_DISABLE', true)

        const response = await api.cancelSubmission({ params: { approval_id: state.item.pending_approval.approval_id } })
        if (response.data.success) {
          commit('RESET_WAIT_APPROVAL_DIALOG')
          commit('RESET_CHANGES_APPROVAL_DIALOG')
          commit('SET_SNACKBAR', { status: true, color: 'success', text: Vuetify.locale.t('$vuetify.__SnackBar.cancel'), icon: 'check', timeout: '2000' })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_WAIT_APPROVAL_DIALOG_SUBMIT_BTN_DISABLE', false)
      }
    }
  }
}
